export enum LogTypeEnum {
  INFO = "INFO",
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUSPICIOUS = "SUSPICIOUS"
}

export const LogTypeEnumValues: string[] = [
  LogTypeEnum.INFO,
  LogTypeEnum.ERROR,
  LogTypeEnum.WARNING,
  LogTypeEnum.SUSPICIOUS
]
